class LazyloadImage {

	constructor(){
		this.lazyloadElement = document.querySelectorAll(`[data-lazyload]`);
		this._init();
	}

	_init(){
		for(const item of this.lazyloadElement){
			item.addEventListener('visible', (event)=>this._loadImages(event) );
		}
	}


	_loadImages(event){
		const element  = event.target;
		const imageURL = element.getAttribute('data-lazyload-src');

		const image = new Image();
		image.src   = imageURL;
		image.onload = ()=> {
			element.style.backgroundImage = `url(${imageURL})`;
			element.setAttribute('data-lazyload-state', 'loaded');
		};
	}
}

export const lazyloadImage = new LazyloadImage();